/* Root styles: should be imported before other styles
 */

:host {
  container-type: inline-size;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  font-family: var(--_font-family);
  color: var(--_foreground-color);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
}

h1 {
  font-size: 1.875rem;
  font-weight: inherit;
  padding: 1rem 0;
}

h2 {
  font-size: 1.5rem;
  font-weight: inherit;
  padding: 1rem 0;
}

h3 {
  font-size: 1.25rem;
  font-weight: inherit;
}

h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

p {
  padding: 0.5rem 0;
}

a {
  color: var(--_link-fg);
  cursor: pointer;
}

ul {
  padding: 1rem 0 1rem 2rem;
  list-style-type: disc;
}

kbd {
  border: 0.1em solid var(--_kbd-border-color);
  border-radius: 0.2em;
  display: inline-block;
  padding: 0em 0.5em;
  background: var(--_kbd-background);
  color: var(--_kbd-fg);
  font-weight: bold;
}

button {
  touch-action: manipulation;
}
